import scrapSuccess from '../../../assets/scrapSuccess.png';

export default function PostScrapSuccessIcon() {
  return (
      <img src={scrapSuccess} alt='' />
  );
}